module.exports = "https://coursera_assets.s3.amazonaws.com/images/1f9c08c24835b4ea134411e3ff63594a.png";